import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import SharedScript from '@americanexpress/shared-scripts';
import { compose } from 'redux';
import childRoutes from '../childRoutes';
import { reducer } from '../ducks';

const DocumentCommunicationsRoot = ({ languageData, children }) => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.getIn(['intl', 'activeLocale']));

  useEffect(() => {
    dispatch(loadLanguagePack('axp-document-communications-root', { fallbackLocale: 'en-US' }));
  }, [dispatch, locale]);

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <Helmet
        htmlAttributes={{ lang: locale }}
        link={[
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css',
          },
        ]}
      >
        <title>Document Center</title>
        <body className="dls-gray-02-bg" />
      </Helmet>
      <SharedScript
        id="one-identity-script"
        name="one-identity-session"
        version="^1.0.0"
        windowCheck="AmexSession"
      />
      <main>
        <h1 className="sr-only">Document Center</h1>
        {children}
      </main>
    </IntlProvider>
  );
};
export const TestableDocumentCommunicationsRoot = DocumentCommunicationsRoot;
DocumentCommunicationsRoot.childRoutes = childRoutes;

const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(
    loadLanguagePack('axp-document-communications-root', { fallbackLocale: 'en-US' })
  );
};

DocumentCommunicationsRoot.holocron = {
  name: 'axp-document-communications-root',
  loadModuleData,
  reducer,
};

DocumentCommunicationsRoot.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack

  children: PropTypes.node,
};

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require
  DocumentCommunicationsRoot.appConfig = require('../appConfig').default;
}

const hocChain = compose(oneAppModuleWrapper('axp-document-communications-root'));

export { DocumentCommunicationsRoot as ComponentUnderTest, loadModuleData };
export default hocChain(DocumentCommunicationsRoot);
